















import { Vue, Component } from 'vue-property-decorator';
import * as config from './config';
import { autoOpenApp } from '@/common/ts/common';
import { appShare, wxShareInfo, isWeiXin } from '@/common/ts/common';
import { getDetailData } from './api/index';
@Component({
  name: 'Detail',
  components: {
  },
})
export default class Detail extends Vue {
  showImg = true;
  detailData: any = [];
  option = config.OPTHINES;
  created() {
    console.log('source:' + this.$route.query.dataSource);
    getDetailData(Number(this.$route.query.id)).then((res) => {
      this.detailData = res.data;
    });
  }
}
